import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=7e8b70d5&scoped=true&"
import script from "./Bar.vue?vue&type=script&lang=js&"
export * from "./Bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b70d5",
  null
  
)

export default component.exports